import HttpWrapper from '@utils/http/httpWrapper'
import ShipbobAppSettings from '../../appSettings/appSetting'
import toastr from 'toastr'

export const PRICING_API = ShipbobAppSettings.MerchantPricingApi.ApiBaseUrl
export const ADDRESS_VALIDATOR_API = ShipbobAppSettings.addressValidator + '/api'
export const ADDRESS_VALIDATOR_APIKEY = ShipbobAppSettings.addressValidatorApiKey

class PricingPlanServiceInternal {
  urls () {
    return {
      getPricingZones: PRICING_API + 'PricingZones',
      getRates: PRICING_API + 'Pricing',
      getWroLabelQuotes: PRICING_API + 'wro/price',
      getWroLabelQuotesByShipOption: PRICING_API + 'wro/v2/price',
      getIsCrossBorderShipmentBulk: `${ADDRESS_VALIDATOR_API}/AddressValidator/IsCrossBorderShipmentBulk`,
      getPricingRates: `${PRICING_API}/pricing/FindPricingRates`,
      getUserHomeCountry: `${PRICING_API}User/HomeCountry`,
      getDefaultRatesByHomeCountry: `${PRICING_API}Pricing/DefaultRates`,
      getReturnQuotes: `${PRICING_API}ReturnPricing/v2/price`,
      getUserCountryCurrencyMappings: `${PRICING_API}User/CountryCurrencies`,
      getPricingTenant: `${PRICING_API}v1/pricing-tenant`
    }
  }

  async getPricingZones ({ fulfillmentCenterId, destinationCountryIsoCodes }) {
    const commaSeparatedDestinationCountryIsoCodes = destinationCountryIsoCodes.toString()
    const request = {
      Url: `${this.urls().getPricingZones}/${fulfillmentCenterId}/${commaSeparatedDestinationCountryIsoCodes}`
    }

    return await HttpWrapper.Get(request, undefined, this.handleGetPricingZonesError, true)
  }

  async getPricingPlan ({ shipOptionId, zoneIds }) {
    const commaSeparatedZoneIds = zoneIds.toString()
    const request = {
      Url: `${this.urls().getRates}/${commaSeparatedZoneIds}/${shipOptionId}`
    }

    return await HttpWrapper.Get(request, undefined, this.handleGetPricingPlanError, true)
  }

  async getWroLabelQuotes ({ boxes, destinationInformation }) {
    const request = {
      Url: `${this.urls().getWroLabelQuotes}`,
      Data: { boxes, destinationInformation }
    }

    return await HttpWrapper.Post(request)
  }

  async getWroLabelQuotesByShipOption ({ boxes, destinationInformation }) {
    const request = {
      Url: `${this.urls().getWroLabelQuotesByShipOption}`,
      Data: { boxes, destinationInformation }
    }

    return await HttpWrapper.Post(request)
  }

  async getReturnQuotesByShipOption (data) {
    const request = {
      Url: `${this.urls().getReturnQuotes}`,
      Data: data
    }

    return await HttpWrapper.Post(request)
  }

  async getPricingRates (pricingRequest) {
    const request = {
      Url: `${this.urls().getPricingRates}`,
      Data: pricingRequest
    }

    return await HttpWrapper.Post(request)
  }

  async getUserHomeCountry () {
    const request = {
      Url: `${this.urls().getUserHomeCountry}`
    }

    return await HttpWrapper.Get(request, null, null, true)
  }

  async getUserCountryCurrencyMappings () {
    const request = {
      Url: `${this.urls().getUserCountryCurrencyMappings}`
    }

    return await HttpWrapper.Get(request, null, null, true)
  }

  async getDefaultRatesByHomeCountry (countryId, currencyCode) {
    const request = {
      Url: `${this.urls().getDefaultRatesByHomeCountry}/${countryId}/${currencyCode}`
    }

    return await HttpWrapper.Get(request, null, null, true)
  }

  async getIsCrossBorderShipmentBulk (isCrossBorderShipmentRequest) {
    const request = {
      Url: this.urls().getIsCrossBorderShipmentBulk,
      Headers: { apiKey: ADDRESS_VALIDATOR_APIKEY },
      Data: isCrossBorderShipmentRequest
    }

    return await HttpWrapper.Post(request)
  }

  async getPricingTenant () {
    const request = {
      Url: `${this.urls().getPricingTenant}`
    }

    return await HttpWrapper.Get(request, null, null, true)
  }

  handleGetPricingZonesError () {
    toastr.error('Unable to retrieve pricing zones')
  }

  handleGetPricingPlanError () {
    toastr.error('Unable to retrieve pricing plan')
  };
}

export const PricingPlanService = new PricingPlanServiceInternal()
